module.exports = __webpack_public_path__ + "img/xianzhi.db8ffcab.png";